import ReactGA from 'react-ga4';

export const initializeGA = (options = {}) => {
  ReactGA.initialize('G-S8P4VV5MWR', { ...options });
};


export const eventGA = (event) => {
  ReactGA.event({ ...event });
};

export const setDataGA = data => ReactGA.set(data);

export const modalViewGA = title => {
  // ReactGA.modalview(title);
};
